import request from '../../../core/wrappers/axios-wrapper';
import { ApiURL } from '../../../types/constants/apiUrls/api-urls';
import { RequestType } from '../../../types/enums/request-enums';

const BulkUpdateFastDeliveryCargoSettings = (data: any) => request({
    url: ApiURL.Command.BulkUpdateFastDeliveryCargoSettings,
    method: RequestType.POST,
    data: data
});

const UpdateFastDeliveryCargo = (data: {
    shippingCompanyId: number;
    addressEntityId: number;
    isActiveForTomorrowDelivery: boolean;
    isActiveForTodayDelivery: boolean;
    isActiveForExpressDelivery: boolean;
}) => request({
    url: ApiURL.Command.UpdateFastDeliveryCargo,
    method: RequestType.POST,
    data: data
});

const AddFastDeliveryCargo = (data: {
    shippingCompanyId: number;
    addressEntityId: number;
    isActiveForTomorrowDelivery: boolean;
    isActiveForTodayDelivery: boolean;
    isActiveForExpressDelivery: boolean;
}) => request({
    url: ApiURL.Command.UpdateFastDeliveryCargo, //upsert
    method: RequestType.POST,
    data: data
});

const BulkUploadFastDeliveryCargo = (formData: FormData): Promise<any> =>
    request({
        url: ApiURL.Command.BulkUploadFastDeliveryCargo,
        method: RequestType.POST,
        data: formData,
        requestType: 'FromForm',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'multipart/form-data'
        }
    });

const FastDeliveryCargoManagementCommand = {
    BulkUpdateFastDeliveryCargoSettings,
    UpdateFastDeliveryCargo,
    AddFastDeliveryCargo,
    BulkUploadFastDeliveryCargo,
};

export default FastDeliveryCargoManagementCommand; 